document.addEventListener('click', (event) => {
  const checkoutButton = document.querySelector('button.cart__checkout-button[name="checkout"]');
  if (checkoutButton.contains(event.target) && window.hulkapps != undefined && is_draft_order) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    hulkappsCheckout();
  }
}, true);